export enum PenaltyType {
    DuringPlay,
    AfterPlay
}